<template>
    <div class="global-search">
        <side-by-side v-if="view === 'side-by-side'"></side-by-side>
        <master-detail v-if="view === 'master-detail'"></master-detail>
    </div>
</template>

<script>
    import { breakpoints } from "@utilities/sal-breakpoint/sal-breakpoint";
    import SearchArea from "@search/components/search-area/search-area.vue";
    import SearchCategories from "@search/components/search-categories/search-categories.vue";
    import SideBySide from "@search/view/side-by-side.vue";
    import MasterDetail from "@search/view/master-detail.vue";
    export default {
        name: "global-search",
        components: {MasterDetail, SideBySide, SearchCategories, SearchArea},
        props: {
            searchUrl: ''
        },
        data() {
            return {
                view: 'side-by-side',
            }
        },
        computed: {
        },
        methods: {
            evaluateCurrentView() {
                if (window.innerWidth < breakpoints.md) {
                    this.view = 'master-detail'
                } else {
                    this.view = 'side-by-side'
                }
            }
        },
        beforeMount() {
            const url = new URL(window.location.href);
            const query = url.searchParams.get("tx_salbase9_search[q]");
			let category = url.searchParams.get("tx_salbase9_search[cat]");

            this.$store.dispatch('setSearchUrl', { url: this.searchUrl });
            this.$store.dispatch('fetchLocalization');

            if (query) {
                this.$store.dispatch('setKeyword', { keyword: query });
            }
			if (category) {
				this.$store.dispatch('changeCategory', category);
				this.$store.dispatch('showDetailView', true);
			}

			this.$store.dispatch('fetchInitialResults');

            window.addEventListener('resize', this.evaluateCurrentView);
            this.evaluateCurrentView();
        }
    }
</script>
